import { axiosBeelineRequest } from '@beef/utils';
import { getIsLoggedIn } from "../getIsLoggedIn/dev";
import { getWindow } from "../../../utils/window";
import { Content } from "../getContent/Content";
import { getInitialize } from "./logic";
export var initialize = getInitialize({
  fetchContent: function fetchContent() {
    return axiosBeelineRequest({
      url: '/api/texts/balancepopup_content'
    });
  },
  fetchSavedCards: function fetchSavedCards() {
    var _getWindow$paymentTog, _getWindow;
    var _Content$getInstance$ = Content.getInstance().getData(),
      paymentRBS = _Content$getInstance$.paymentRBS;
    var _ref = (_getWindow$paymentTog = (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : _getWindow.paymentToggles) !== null && _getWindow$paymentTog !== void 0 ? _getWindow$paymentTog : {},
      isRbsEnabled = _ref.isRbsEnabled;
    var PAYMENT_RBS = isRbsEnabled !== null && isRbsEnabled !== void 0 ? isRbsEnabled : paymentRBS;
    if (!PAYMENT_RBS) return axiosBeelineRequest({
      url: '/api/v1/payment/bankCards',
      params: {
        activeOnly: false
      }
    });
    return axiosBeelineRequest({
      url: '/api/v1/payment/bindings',
      params: {
        activeOnly: false
      }
    }).then(function (res) {
      var _res$bindings;
      return {
        cards: (_res$bindings = res.bindings) === null || _res$bindings === void 0 ? void 0 : _res$bindings.map(function (b) {
          return {
            paymentSystem: b.paymentSystem,
            token: b.bindingId,
            type: b.bankName,
            last4: b.displayLabel
          };
        })
      };
    });
  },
  fetchSberpayBindings: function fetchSberpayBindings() {
    return axiosBeelineRequest({
      url: '/api/sberpay/binding/'
    });
  },
  fetchSbpBindings: function fetchSbpBindings() {
    return axiosBeelineRequest({
      url: '/sbpapi/binding'
    });
  },
  getContentInstance: Content.getInstance.bind(Content),
  getIsLoggedIn: getIsLoggedIn,
  getWindow: getWindow
});